import CanalModel from './CanalModel'
import TiposDeCanaisEnum from './TiposDeCanaisEnum'

export default class CanalAutoatendimentoModel extends CanalModel {
  constructor({
    id = 0,
    nome = '',
    descricao = '',
    url = null,
    dns1 = '',
    dns2 = '',
    tituloHeader = '',
    headerHtml = '',
    footerHtml = '',
    fotoId = null,
    urlAlias = null,
  } = {}) {
    super(id, nome, descricao, TiposDeCanaisEnum.Autoatendimento)
    this.url = url
    this.dns1 = dns1
    this.dns2 = dns2
    this.tituloHeader = tituloHeader
    this.headerHtml = headerHtml
    this.footerHtml = footerHtml
    this.fotoId = fotoId
    this.urlAlias = urlAlias
  }
}
